import { render, staticRenderFns } from "./PlantPage.vue?vue&type=template&id=6ac60af7&"
import script from "./PlantPage.vue?vue&type=script&lang=ts&"
export * from "./PlantPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports